<aside title="skip link">
  <a class="nhsuk-skip-link" [routerLink]="skipLinkPath" [fragment]="fragment">
    {{ text }}
  </a>
</aside>
